import React from "react";

/**
 * Custom dark schematic map at SVMD office coordinates.
 * Stylised street grid, voltage marker pulse, on-brand.
 * No third-party JS.
 */
export default function SVGMap({ className = "" }) {
  return (
    <div className={`relative overflow-hidden bg-ink ${className}`} data-testid="contact-map">
      <svg viewBox="0 0 800 600" preserveAspectRatio="xMidYMid slice" className="w-full h-full">
        <defs>
          <linearGradient id="mp-bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0A1628" />
            <stop offset="100%" stopColor="#0F2847" />
          </linearGradient>
          <radialGradient id="mp-marker-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D4FF3F" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#D4FF3F" stopOpacity="0" />
          </radialGradient>
        </defs>

        <rect width="800" height="600" fill="url(#mp-bg)" />

        {/* Subtle latitude/longitude grid */}
        <g stroke="rgba(250,250,247,0.06)" strokeWidth="0.5">
          {Array.from({ length: 12 }).map((_, i) => (
            <line key={`mph${i}`} x1="0" y1={i * 50} x2="800" y2={i * 50} />
          ))}
          {Array.from({ length: 16 }).map((_, i) => (
            <line key={`mpv${i}`} x1={i * 50} y1="0" x2={i * 50} y2="600" />
          ))}
        </g>

        {/* Mettupalayam Road — primary horizontal */}
        <g>
          <line x1="0" y1="300" x2="800" y2="300" stroke="rgba(37,99,235,0.5)" strokeWidth="2.5" />
          <line x1="0" y1="300" x2="800" y2="300" stroke="rgba(212,255,63,0.4)" strokeWidth="0.5" strokeDasharray="2 12" />
          <text x="60" y="290" fill="rgba(250,250,247,0.7)" fontFamily="JetBrains Mono Variable, monospace" fontSize="10" letterSpacing="0.14em">
            METTUPALAYAM ROAD
          </text>
        </g>

        {/* Cross streets */}
        <line x1="240" y1="0" x2="240" y2="600" stroke="rgba(250,250,247,0.18)" strokeWidth="1.2" />
        <line x1="540" y1="0" x2="540" y2="600" stroke="rgba(250,250,247,0.18)" strokeWidth="1.2" />
        <line x1="0" y1="160" x2="800" y2="160" stroke="rgba(250,250,247,0.10)" strokeWidth="1" />
        <line x1="0" y1="450" x2="800" y2="450" stroke="rgba(250,250,247,0.10)" strokeWidth="1" />

        {/* Diagonal road */}
        <line x1="0" y1="600" x2="800" y2="120" stroke="rgba(250,250,247,0.08)" strokeWidth="1" strokeDasharray="2 8" />

        {/* Building blocks (stylised) */}
        <g fill="rgba(250,250,247,0.04)" stroke="rgba(250,250,247,0.10)">
          <rect x="60" y="180" width="140" height="100" />
          <rect x="60" y="320" width="140" height="100" />
          <rect x="280" y="180" width="220" height="100" />
          <rect x="280" y="320" width="220" height="100" />
          <rect x="580" y="180" width="180" height="100" />
          <rect x="580" y="320" width="180" height="100" />
        </g>

        {/* Office marker at center (represents 11.0198, 76.9539) */}
        <g transform="translate(400, 300)">
          <circle r="72" fill="url(#mp-marker-glow)">
            <animate attributeName="r" values="56;76;56" dur="3.2s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.9;0.4;0.9" dur="3.2s" repeatCount="indefinite" />
          </circle>
          <circle r="22" fill="#D4FF3F" stroke="#0A1628" strokeWidth="2" />
          <circle r="6" fill="#0A1628" />
          <text y="48" textAnchor="middle" fill="#D4FF3F" fontFamily="Inter Variable, sans-serif" fontWeight="600" fontSize="12" letterSpacing="0.06em">
            SVMD &amp; ASSOCIATES
          </text>
          <text y="64" textAnchor="middle" fill="rgba(250,250,247,0.7)" fontFamily="JetBrains Mono Variable, monospace" fontSize="10" letterSpacing="0.14em">
            373/3 · NEAR FACT, VADAKOVAI
          </text>
        </g>

        {/* Coordinate display */}
        <g>
          <text x="40" y="560" fill="rgba(250,250,247,0.55)" fontFamily="JetBrains Mono Variable, monospace" fontSize="11" letterSpacing="0.14em">
            LAT 11.019766° N
          </text>
          <text x="40" y="580" fill="rgba(250,250,247,0.55)" fontFamily="JetBrains Mono Variable, monospace" fontSize="11" letterSpacing="0.14em">
            LNG 76.953854° E
          </text>
        </g>

        {/* Compass */}
        <g transform="translate(740, 60)">
          <circle r="24" fill="rgba(255,255,255,0.04)" stroke="rgba(250,250,247,0.2)" />
          <line x1="0" y1="-18" x2="0" y2="18" stroke="rgba(250,250,247,0.4)" strokeWidth="0.6" />
          <line x1="-18" y1="0" x2="18" y2="0" stroke="rgba(250,250,247,0.4)" strokeWidth="0.6" />
          <polygon points="0,-18 -3,0 0,-4 3,0" fill="#D4FF3F" />
          <text y="-26" textAnchor="middle" fill="#D4FF3F" fontSize="9" fontFamily="Inter Variable, sans-serif" fontWeight="600">N</text>
        </g>
      </svg>
    </div>
  );
}
